import { Customer } from '../../types/customer';
import { Action, SET_CUSTOMERS } from './actions';

export default (
  state: Customer[] = null as any,
  action: Action
): Customer[] => {
  switch (action.type) {
    case SET_CUSTOMERS:
      return action.payload;
    default:
      return state;
  }
};
